var map = {
	"./BMW-IX3.png": "259b",
	"./BMW-IX3.webp": "61ce",
	"./BYD-Atto-3-Extended-Range.png": "bdb5",
	"./MG-ZS-EV-D.png": "ffcb",
	"./NISSAN-Leaf-2.jpeg": "aaa3",
	"./TESLA Model Y Long Range.webp": "633a",
	"./TESLA-Model-3.jpeg": "2bc8",
	"./TESLA-Model-Y.jpeg": "8275",
	"./volvo.png": "a686"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0a29";